|<template>
  <div>
    <h3>{{ $t('pages.killer-questions-templates.actions.title', 'Actions') }}</h3>
    <div class="row py-2 px-3">
      <div class="col-12 col-lg-6 mb-2">
        <div class="row">
          <div class="col-1">
            <font-awesome-icon
              icon="plus-square"
            />
          </div>
          <div class="col-10">
            <router-link
              :to="{ name: 'killerq-templates-add-question' }"
              :class="{ disabled : !rootFolderExists }"
            >
              {{ $t('pages.killer-questions-templates.actions.new-question-title', 'New Killer Question') }}
            </router-link>
            <div class="subtext">
              {{ $t('pages.killer-questions-templates.actions.new-question-desc', 'Create a question and save it to use in different offers.') }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="row">
          <div class="col-1">
            <font-awesome-icon
              icon="folder-plus"
            />
          </div>
          <div class="col-10">
            <router-link :to="{ name: 'killerq-templates-add-folder' }">
              {{ $t('pages.killer-questions-templates.actions.new-folder-title', 'New Folder') }}
            </router-link>
            <div class="subtext">
              {{ $t('pages.killer-questions-templates.actions.new-folder-desc', 'Organize your questions in folders so you can easily locate them.') }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="row">
          <div class="col-1">
            <font-awesome-icon
              icon="pen-square"
            />
          </div>
          <div class="col-10">
            <router-link
              :to="{ name: 'killerq-templates-manage-question' }"
              :class="{ disabled : !rootFolderExists }"
            >
              {{ $t('pages.killer-questions-templates.actions.edit-question-title', 'Manage Killer Questions') }}
            </router-link>
            <div class="subtext">
              {{ $t('pages.killer-questions-templates.actions.edit-question-desc', 'Modify or delete the questions you have previously created.') }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="row">
          <div class="col-1">
            <font-awesome-icon
              icon="file-signature"
            />
          </div>
          <div class="col-10">
            <router-link
              :to="{ name: 'killerq-templates-manage-folder' }"
              :class="{ disabled : !rootFolderExists }"
            >
              {{ $t('pages.killer-questions-templates.actions.edit-folder-title', 'Manage Folders') }}
            </router-link>
            <div class="subtext">
              {{ $t('pages.killer-questions-templates.actions.edit-folder-desc', 'Modify or delete the folders that you have previously created.') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      rootFolderExists: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .subtext {
    font-size: 0.8rem;
  }

  a.disabled {
    color: gray !important;
    pointer-events: none;
  }
</style>